<template>
  <ModalBlock
    :model="localModel"
    @update:model="localModel = $event"
    @update:modelValue="localModel = $event"
  >
    <div :class="style.modal" :style="styleModal">
      <div :class="style.content">
        <h3 v-if="title" :class="style.title">
          {{ title }}
        </h3>

        <p v-if="subtitle" :class="style.subtitle">
          {{ subtitle }}
        </p>
      </div>

      <div v-if="actions.length" :class="style.buttons">
        <SecondaryButton
          v-if="secondaryButton"
          :text="secondaryButton.text"
          :disabled="secondaryButton.disabled"
          @click="handleAction(secondaryButton)"
        />

        <PrimaryButton
          v-if="primaryButton"
          :text="primaryButton.text"
          :disabled="primaryButton.disabled"
          @click="handleAction(primaryButton)"
        />
      </div>
    </div>
  </ModalBlock>
</template>

<script lang="ts">
import {defineComponent, PropType} from "vue";
import ModalBlock from "@/layout/nav/components/modal/ModalBlock.vue";
import PrimaryButton from "@/elements/UI/button/ButtonStyle/Default/primary/PrimaryButton.vue";
import SecondaryButton from "@/elements/UI/button/ButtonStyle/Default/secondary/SecondaryButton.vue";
import style from "./ActionModal.module.scss";

export default defineComponent({
  name: "ActionModal",

  components: {
    ModalBlock,
    PrimaryButton,
    SecondaryButton
  },

  emits: ["update:modelValue"],

  props: {
    modelValue: {
      type: Boolean,
      default: false
    },

    title: {
      type: String,
      default: ""
    },

    subtitle: {
      type: String,
      default: ""
    },

    actions: {
      type: Array as PropType<ListActionItem[]>,
      default: () => []
    },
    width: {
      type: Number,
      default: 352
    }
  },

  data() {
    return {
      style
    };
  },

  computed: {
    localModel: {
      get(): boolean {
        return this.modelValue;
      },

      set(value: boolean): void {
        this.$emit("update:modelValue", value);
      }
    },

    secondaryButton(): ListActionItem | undefined {
      return this.actions[0];
    },

    primaryButton(): ListActionItem | undefined {
      return this.actions[1];
    },
    styleModal() {
      return {
        width: `${this.width}px`
      };
    }
  },

  methods: {
    async handleAction(action: ListActionItem): Promise<void> {
      if (action.disabled) {
        return;
      }

      if (action.handler) {
        await action.handler();
      }
    }
  }
});
</script>
